import { useMemo } from 'react';
import { usePetParentReportState } from './usePetParentReports';
import { useAdoptionReportState } from './useAdoptionReports';
import { ReportStatus } from '../types/reports';

export interface MissedReportsCount {
  petParentReports: number;
  adoptionReports: number;
  total: number;
}

export const useMissedReportsCount = (): MissedReportsCount => {
  const petParentReports = usePetParentReportState();
  const adoptionReports = useAdoptionReportState();

  return useMemo(() => {
    const petParentMissed =
      petParentReports?.data?.filter(
        (report) => report.status === ReportStatus.Missed && report.canSubmit === true
      ).length ?? 0;

    const adoptionMissed =
      adoptionReports?.data?.filter(
        (report) => report.status === ReportStatus.Missed && report.canSubmit === true
      ).length ?? 0;

    return {
      petParentReports: petParentMissed,
      adoptionReports: adoptionMissed,
      total: petParentMissed + adoptionMissed,
    };
  }, [petParentReports, adoptionReports]);
};
